import MileageIntegrations from './MileageIntegrations';
import ExternalIdentifiers from './ExternalIdentifiers';

const IDENTIFIERS_TAB = { key: 'identifiers', label: 'Identifiers', Component: ExternalIdentifiers };

// Tabs rendered by AccountDetailsModal, keyed by context. Identifiers is available for every account
// type — an admin can set any of their org's ids on any client they work with.
export const DETAILS_TABS = {
    SHIPPER: [{ key: 'mileage', label: 'Mileage', Component: MileageIntegrations }, IDENTIFIERS_TAB],
    NETWORK: [IDENTIFIERS_TAB],
    FLEX: [IDENTIFIERS_TAB],
    CONTRACTOR: [IDENTIFIERS_TAB],
};
